<template>
  <section class="ProfessionPageSectionAdviceBlock adviceBlock">
    <div class="sideBlocks">
      <ProfessionPriceRangesBox
        :profession="profession"
        :profession-tasks="professionTasks"
        class="mb-4"
      />
      <div class="floater">
        <TableOfContents
          v-if="profession.mainPageContentHtml"
          :content="profession.mainPageContentHtml"
        />
        <template v-for="(priceCalculator, index) in priceCalculators">
          <SideBlock :key="index" :title="$t('priceCalculator.fallbackTitle')">
            <i18n path="professionalsPage.calculatePrice">
              <template #link>
                <NuxtLink :to="priceCalculator.path" target="_blank">
                  {{
                    $t("professionalsPage.calulatePriceLink", {
                      priceCalculatorName: priceCalculator.name,
                    })
                  }}</NuxtLink
                >
              </template>
            </i18n>
          </SideBlock>
        </template>
        <QuickOfferBox />
        <SideBlock
          v-if="inspirations?.length"
          :title="$t('professionPage.relatedInspirations')"
        >
          <ol>
            <li v-for="(inspiration, index) in inspirations" :key="index">
              <NuxtLink
                :to="
                  localePath({
                    name: 'inspirationPage',
                    params: { inspirationSeoName: inspiration.seoName },
                  })
                "
              >
                {{ inspiration.name }}
              </NuxtLink>
            </li>
          </ol>
        </SideBlock>
        <SideBlock
          v-if="articles?.length"
          :title="
            $t('profBlogsBox.title', {
              professionName: $helpers.capitalize(profession.name),
            })
          "
        >
          <ul class="mb-2">
            <li v-for="(article, index) in articles" :key="index" class="mb-1">
              <NuxtLink
                :to="
                  localePath({
                    name: 'blogArticlePage',
                    params: { articleSeoName: article.seoTitle },
                  })
                "
              >
                {{ article.title }}
              </NuxtLink>
            </li>
          </ul>
          <JoszakiButton
            :to="
              localePath({
                name: 'blogListPageByProfession',
                params: { professionSeoName: profession.seoName },
              })
            "
          >
            {{ $t("profBlogsBox.allBlogs") }}
          </JoszakiButton>
        </SideBlock>
      </div>
    </div>
    <div v-if="profession.mainPageContentHtml" class="advices">
      <TableOfContents
        class="lg:hidden"
        :content="profession.mainPageContentHtml"
      />
      <JoszakiHtmlTextBlock :text="profession.mainPageContentHtml" />
    </div>
  </section>
</template>

<script>
import { inject } from "@nuxtjs/composition-api";
import TableOfContents from "~/components/_refactored/app/boxes/TableOfContents";
import JoszakiHtmlTextBlock from "~/components/_refactored/common/JoszakiHtmlTextBlock.vue";
import SideBlock from "~/components/_refactored/mainpage/SideBlock.vue";
import ProfessionPriceRangesBox from "~/components/_refactored/profession/ProfessionPriceRangesBox.vue";
import QuickOfferBox from "~/components/professionTaskPage/quickOfferBox";

export default {
  components: {
    SideBlock,
    ProfessionPriceRangesBox,
    TableOfContents,
    QuickOfferBox,
    JoszakiHtmlTextBlock,
  },
  setup() {
    return {
      profession: inject("profession"),
      inspirations: inject("inspirations"),
      professionTasks: inject("professionTasks"),
      articles: inject("articles"),
    };
  },
  computed: {
    priceCalculators() {
      return this.professionTasks
        .filter((task) => task.priceCalculator?.id)
        .map((task) => {
          return {
            name: task.name,
            path: this.localePath({
              name: "priceCalculatorPage",
              params: {
                professionTask: task.seoName,
              },
            }),
          };
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@use "styles/_all-members" as global;

.adviceBlock {
  margin-top: 40px;
  margin-bottom: 24px;
  display: grid;
  gap: 50px;
  grid-template-columns: 1fr 1fr 1fr;
  position: relative;

  .advices {
    grid-column: span 2;
    max-width: 800px;
    @include global.touch {
      grid-column: span 3;
      max-width: unset;
    }
  }

  .sideBlocks {
    order: 0;
    position: relative;
    @include global.touch {
      display: none;
    }

    .floater {
      position: relative;
      position: sticky;
      top: 1rem;
      display: grid;
      gap: 1rem;
    }
  }
}

.noAdviceContentBlock {
  width: 100%;
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  margin-bottom: 20px;
}
</style>
